import { render, staticRenderFns } from "./ModificarVendedor.vue?vue&type=template&id=6208fcb1&scoped=true&"
import script from "./ModificarVendedor.vue?vue&type=script&lang=js&"
export * from "./ModificarVendedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6208fcb1",
  null
  
)

export default component.exports